<template>
<div class="">
  <vue-headful
    title="💌 – Yay verified!"
/>
    <h3>YAY You just verified yourself</h3>
    <router-link :to="'/to/'+ url">{{url}}</router-link>
</div>
</template>

<script>
import firebase from 'firebase'

export default {
    name: 'verified',
    data() {
        return {
            email: '',
            url: ''
        }
    },
    mounted: function() {
        this.signed()
    },
    methods: {
        currentUser: function() {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    alert(user.uid);
                }
            })
        },
        signed: function() {

            if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
                this.email = localStorage.email
                if (!this.email) {
                    this.email = window.prompt('Please provide your email for confirmation');
                }
                this.url = this.email.replace(/.*@/, "")

                firebase.auth().signInWithEmailLink(this.email, window.location.href)
                    .then(function(result) {
                        localStorage.removeItem('email');
                    })
                    .catch(function(error) {

                    });
            }

        }
    },
}
</script>
